import {TaskType} from './task';
import {SubRole, SystemRole, User} from './user';

export interface AccessPolicyDto {
  version: number;
  name: string;
  evaluation: AccessPolicyEvaluationDto | null;
  contextContract: AccessPolicyContextContractDto | null;
  predicates: Record<string, AccessPolicyPredicateDto>;
  actions: Record<string, string[]>;
  matrix: AccessPolicyMatrixRuleDto[];
}

export interface AccessPolicyEvaluationDto {
  strategy: string;
  defaultEffect: string;
}

export interface AccessPolicyContextContractDto {
  user: string[];
  ctx: string[];
}

export interface AccessPolicyPredicateDto {
  logic: AccessPolicyLogicNode | null;
}

export interface AccessPolicyMatrixRuleDto {
  resource: string;
  action: string;
  projectRole: string[] | null;
  boardRole: string[] | null;
  taskType: string[] | null;
  effect: string;
  condition: string | null;
}

export type AccessPolicyLogicNode =
  | null
  | string
  | number
  | boolean
  | AccessPolicyLogicNode[]
  | AccessPolicyLogicObject;

export interface AccessPolicyLogicObject {
  [key: string]: AccessPolicyLogicNode;
}

export interface AccessPolicyUserContext {
  id: number | null;
  systemRole: SystemRole | null;
  companyId: number | null;
  tradeId: number | null;
}

export interface AccessPolicyContext {
  companyId?: number | null;
  tradeId?: number | null;
  projectId?: number | null;
  projectArchived?: boolean | null;
  projectRole?: SubRole | null;
  boardId?: number | null;
  boardRole?: SubRole | null;
  authorId?: number | null;
  creatorId?: number | null;
  memberId?: number | null;
  creatorTradeId?: number | null;
  taskTradeId?: number | null;
  authorSystemRole?: SystemRole | null;
  taskType?: TaskType | null;
}

export interface AccessPolicyDecision {
  allowed: boolean;
  effect: string;
  resource: string;
  action: string;
  matchedRuleIndex: number | null;
  matchedCondition: string | null;
}

export function buildAccessPolicyUserContext(user: User | null | undefined): AccessPolicyUserContext | null {
  if (!user) {
    return null;
  }

  return {
    id: user.id ?? null,
    systemRole: user.systemRole ?? null,
    companyId: user.company?.id ?? null,
    tradeId: user.trade?.id ?? null
  };
}
